import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-2 sm:mb-0" }
const _hoisted_2 = { class: "rounded border-gray-200 bg-gray-50 px-1.5 py-0.5 text-xs ring-1 ring-gray-300" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-3 lg:grid-cols-6" }
const _hoisted_4 = { class: "flex flex-wrap items-center space-x-1 text-sm text-gray-600" }
const _hoisted_5 = { class: "truncate" }
const _hoisted_6 = { class: "flex flex-wrap items-center space-x-1 text-sm text-gray-600" }
const _hoisted_7 = { class: "ml-0.5 truncate" }
const _hoisted_8 = { class: "flex flex-col text-sm" }
const _hoisted_9 = { class: "text-xs text-gray-400" }
const _hoisted_10 = {
  key: 0,
  class: "truncate"
}
const _hoisted_11 = {
  key: 1,
  class: "truncate"
}
const _hoisted_12 = {
  key: 2,
  class: "truncate"
}
const _hoisted_13 = { class: "flex flex-col text-sm" }
const _hoisted_14 = { class: "text-xs text-gray-400" }
const _hoisted_15 = { class: "truncate" }
const _hoisted_16 = { class: "flex flex-col text-sm" }
const _hoisted_17 = { class: "text-xs text-gray-400" }
const _hoisted_18 = {
  key: 0,
  class: "truncate"
}
const _hoisted_19 = {
  key: 1,
  class: "truncate"
}
const _hoisted_20 = {
  key: 0,
  class: "flex items-center lg:justify-end"
}
const _hoisted_21 = { class: "mt-2 grid grid-cols-2 gap-3 border-t pt-3 lg:grid-cols-6" }
const _hoisted_22 = { class: "flex items-center space-x-1 text-xs text-gray-600" }
const _hoisted_23 = { class: "truncate" }
const _hoisted_24 = { class: "truncate" }
const _hoisted_25 = { class: "flex items-center space-x-1 text-xs text-gray-600" }
const _hoisted_26 = { class: "flex items-center space-x-1 text-xs text-gray-600" }
const _hoisted_27 = { class: "flex items-center text-xs text-gray-600" }
const _hoisted_28 = { class: "ml-1" }
const _hoisted_29 = {
  key: 0,
  class: "rounded border bg-white px-1.5 py-0.5 text-xs text-gray-500"
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "col-span-2 flex items-start text-xs text-gray-600" }
const _hoisted_32 = { class: "flex h-full items-center" }
const _hoisted_33 = { class: "-my-0.5 flex flex-wrap px-1" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  key: 0,
  class: "flex items-center gap-2 text-xs text-gray-600"
}

import { computed, PropType } from 'vue';
import moment from 'moment';

import { CallAudioDownloadButton } from '@/views/pages/call/components';
import {
    CalculatorIcon,
    CalendarIcon,
    ClockIcon,
    PhoneIcon,
    PhoneIncomingIcon,
    PhoneOutgoingIcon,
    PlayIcon,
    TagIcon,
    UsersIcon,
} from '@heroicons/vue/solid';
import { CallStatus, CallStatusClassMap, CallType, CallModel, Permission } from '@/types';
import { can } from '@/composables/useAuth';
import { formatDateAsString, formatSecToTime } from '@/utils/datetime';
import { applyPhoneMask } from '@/utils/number';


export default /*@__PURE__*/_defineComponent({
  __name: 'CallDetails',
  props: {
    call: {
        type: Object as PropType<CallModel>,
        required: true,
    },
    showViewButton: {
        type: Boolean,
        default: true,
    },
    showDownloadButton: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props;

const duration = computed(() => {
    return moment(props.call?.endedAt).diff(moment(props.call.answeredAt), 'seconds');
});

const waitingTime = computed(() => {
    if (props.call?.status === CallStatus.ANSWERED && props.call.answeredAt) {
        return moment(props.call.answeredAt).diff(moment(props.call?.startedAt), 'seconds');
    }
    return moment(props.call.endedAt).diff(moment(props.call?.startedAt), 'seconds');
});

const agents = computed(() => {
    const agentsNames: string[] = [];
    props.call?.events.forEach((e) => {
        if (e.sourceUser) {
            if (!agentsNames.includes(e.sourceUser.name)) {
                agentsNames.push(e.sourceUser.name);
            }
        }
        if (e.destinationUser && e.status === CallStatus.ANSWERED) {
            if (!agentsNames.includes(e.destinationUser.name)) {
                agentsNames.push(e.destinationUser.name);
            }
        }
    });
    return agentsNames;
});

const sourceEvent = computed(() => (props.call.events.length ? props.call.events[0] : null));

const destinationEvent = computed(() => {
    if (props.call?.type === CallType.INBOUND && props.call.status === CallStatus.ANSWERED) {
        return props.call?.events.find((event) => event.status === props.call.status);
    } else if (props.call?.type === CallType.OUTBOUND) {
        return props.call?.events[0];
    }
    return props.call?.events[props.call.events.length - 1];
});

const showCallAudioDownloadButton = computed(
    () =>
        props.showDownloadButton && props.call.audioFilePath && can(Permission.DOWNLOAD_CALL_AUDIO),
);

function formatDestinationNumber(number: string) {
    const pattern = /(\d+)_(\d+)_(\d+)/; // Pattern to match the "211_1_1" like strings
    const match = number.match(pattern);
    if (match) {
        return match[1];
    } else {
        return applyPhoneMask(number);
    }
}

return (_ctx: any,_cache: any) => {
  const _component_UiActionButton = _resolveComponent("UiActionButton")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_component_UiPanel, { class: "hover:bg-white" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, " #" + _toDisplayString(__props.call.id), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (__props.call.type === _unref(CallType).INBOUND)
            ? (_openBlock(), _createBlock(_unref(PhoneIncomingIcon), {
                key: 0,
                class: "h-5 w-5 text-cyan-500",
                "aria-hidden": "true"
              }))
            : (__props.call.type === _unref(CallType).OUTBOUND)
              ? (_openBlock(), _createBlock(_unref(PhoneOutgoingIcon), {
                  key: 1,
                  class: "h-5 w-5 text-orange-500",
                  "aria-hidden": "true"
                }))
              : (__props.call.type === _unref(CallType).INTERNAL)
                ? (_openBlock(), _createBlock(_unref(PhoneIcon), {
                    key: 2,
                    class: "h-5 w-5 text-gray-500",
                    "aria-hidden": "true"
                  }))
                : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(`call.type.${__props.call.type}`)), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex h-2.5 w-2.5 rounded-full", _unref(CallStatusClassMap)[__props.call.status]])
          }, null, 2),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(`call.status.${__props.call.status}`)), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('call.list.origin')), 1),
          (__props.call.contact && __props.call.type === _unref(CallType).INBOUND)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(__props.call.contact.name), 1))
            : (sourceEvent.value?.sourceUser)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(sourceEvent.value.sourceUser.name), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(sourceEvent.value?.sourceNumber ? _unref(applyPhoneMask)(sourceEvent.value.sourceNumber) : '-'), 1))
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('call.list.tracking')), 1),
          _createElementVNode("span", _hoisted_15, _toDisplayString(__props.call.type === _unref(CallType).INBOUND && __props.call.destinationNumber
                        ? _unref(applyPhoneMask)(__props.call.destinationNumber)
                        : '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('call.list.destination')), 1),
          (destinationEvent.value?.destinationUser && __props.call.type !== _unref(CallType).OUTBOUND)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(destinationEvent.value?.destinationUser.name), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(destinationEvent.value?.destinationNumber
                            ? formatDestinationNumber(destinationEvent.value?.destinationNumber)
                            : '-'), 1))
        ]),
        (__props.call.audioFilePath)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (showCallAudioDownloadButton.value)
                ? (_openBlock(), _createBlock(_unref(CallAudioDownloadButton), {
                    key: 0,
                    callId: __props.call.id
                  }, null, 8, ["callId"]))
                : _createCommentVNode("", true),
              (__props.showViewButton && _ctx.$can(_unref(Permission).VIEW_CALL) && __props.call.status == 'ANSWERED')
                ? _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                    key: 1,
                    variant: "primary",
                    to: {
                        name: 'ViewCallById',
                        params: {
                            id: __props.call.id,
                        },
                    }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(PlayIcon), {
                        class: "h-7 w-7",
                        "aria-hidden": "true"
                      }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('core.actions.View')), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])), [
                    [_directive_tippy, _ctx.$t('core.actions.View')]
                  ])
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_unref(CalendarIcon), {
            class: "h-4 w-4",
            "aria-hidden": "true"
          }),
          _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(formatDateAsString)(__props.call.startedAt.toString(), 'DD/MM/YYYY')), 1),
          _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(formatDateAsString)(__props.call.startedAt.toString(), 'HH:mm:ss')), 1)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_unref(ClockIcon), {
            class: "h-4 w-4",
            "aria-hidden": "true"
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('call.list.duration')) + ": ", 1),
          _createElementVNode("span", null, _toDisplayString(__props.call.status == _unref(CallStatus).ANSWERED && __props.call.endedAt
                        ? _unref(formatSecToTime)(duration.value)
                        : '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_unref(ClockIcon), {
            class: "h-4 w-4",
            "aria-hidden": "true"
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('call.list.waitingTime')) + ": ", 1),
          _createElementVNode("span", null, _toDisplayString(__props.call.status != _unref(CallStatus).ON_PROGRESS && __props.call.endedAt !== null
                        ? _unref(formatSecToTime)(waitingTime.value)
                        : '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_unref(TagIcon), {
            class: "mr-1 h-4 w-4",
            "aria-hidden": "true"
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('call.list.media')) + ": ", 1),
          _createElementVNode("div", _hoisted_28, [
            (__props.call.media)
              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(__props.call.media), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_30, "-"))
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_unref(UsersIcon), {
              class: "mr-1 h-4 w-4 flex-shrink-0",
              "aria-hidden": "true"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('call.list.participants')) + ": ", 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            (agents.value.length > 1)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(agents.value, (agent) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "m-0.5 inline-block whitespace-nowrap rounded border bg-white px-1.5 py-0.5 text-xs text-gray-500",
                    key: `agent${__props.call.id}${agent}`
                  }, _toDisplayString(agent), 1))
                }), 128))
              : (_openBlock(), _createElementBlock("span", _hoisted_34, "-"))
          ])
        ]),
        (__props.call.ura !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createVNode(_unref(CalculatorIcon), {
                class: "h-4 w-4",
                "aria-hidden": "true"
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('call.list.ura')) + ": ", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.call.ura, (ura) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "rounded border border-b-gray-400 bg-white px-1",
                  key: `${__props.call.id}${ura.node}`
                }, _toDisplayString(ura.digit), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})